import React from 'react';
import { cn, formatCurrency } from '../../lib/utils';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

export function KpiCard({ title, value, subtitle, icon: Icon, trend, trendValue, className, loading, onClick, ...props }) {
  const trendColor = trend === 'up' ? '#2FBF71' : trend === 'down' ? '#E05252' : '#B9B9B9';
  const TrendIcon = trend === 'up' ? TrendingUp : trend === 'down' ? TrendingDown : Minus;

  return (
    <div 
      className={cn('surface-card card-highlight rounded-xl p-4 animate-fade-in-up', className)} 
      onClick={onClick}
      {...props}
    >
      <div className="flex items-start justify-between mb-3">
        <p className="text-xs text-[#B9B9B9] uppercase tracking-wider font-medium">{title}</p>
        {Icon && (
          <div className="w-8 h-8 rounded-lg bg-[#D4A843]/10 flex items-center justify-center">
            <Icon size={15} className="text-[#D4A843]" />
          </div>
        )}
      </div>
      {loading ? (
        <div className="h-9 w-24 bg-[#202020] rounded animate-pulse" />
      ) : (
        <p className="font-['EB_Garamond'] text-3xl text-[#F2F2F2] tabular-nums leading-none">
          {typeof value === 'number' && title.toLowerCase().includes('revenue') ? formatCurrency(value) : value}
        </p>
      )}
      {subtitle && <p className="text-xs text-[#B9B9B9] mt-1">{subtitle}</p>}
      {trendValue !== undefined && (
        <div className="flex items-center gap-1 mt-2" style={{ color: trendColor }}>
          <TrendIcon size={12} />
          <span className="text-xs">{trendValue}</span>
        </div>
      )}
    </div>
  );
}

export function StatusPill({ status, label }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium status-${status}`}>
      {label || status}
    </span>
  );
}
